<template>
    <rkm-modal
        :buttons="['cancel']"
        ref="RkmModal"
        title="Agenda do dia"
        extraLarge
    >
        <rkm-alert show info>
            <strong>{{dia}} - {{ getStringDiaSemana(semanaId) }}</strong>
        </rkm-alert>

        <rkm-table
            :fields="fields.tables.diaSelecionado"
            :items="items"
            sort-by="horaInicial"
            hide-filters
            hide-pagination
            hover
            striped
        >

            <template v-slot:cell(vagasApp)="row">
                {{ row.item.vagasApp || '-' }}
            </template>

            <template v-slot:cell(tempoAtendimento)="row">
                {{ getTempoAtendimento(row.item.tempoAtendimento) }}
            </template>

            <template v-slot:cell(actions)="{ item, index }">
                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click="edit(item, index)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

export default {
        computed: {
        fields() {
            const columns = [
                { key: 'horaInicial', label: 'Início', sortable: true },
                { key: 'horaFim', label: 'Fim', sortable: true },
                { key: 'vagas', label: 'Vagas cadastradas', sortable: true },
            ]

            if (this.habilitaAgendamentoApp) {
                columns.push({ key: 'vagasApp', label: 'Vagas APP Cidadão', sortable: true })
            }

            columns.push(
                { key: 'agendamentos', label: 'Vagas utilizadas', sortable: true },
                { key: 'vagasDisponiveis', label: 'Vagas disponíveis', sortable: true },
                { key: 'tempoAtendimento', label: 'Tempo de atendimento', sortable: true },
                { key: 'tipoNome', label: 'Tipo de jornada', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min' }
            )

            return { tables: { diaSelecionado: columns } }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        dia: null,
        semanaId: null,
    }),
    methods: {
        open(item, diaSelecionado, diaTratado, semanaId) {

            this.item = item

            this.items = diaSelecionado

            this.dia = diaTratado

            this.semanaId = semanaId

            this.$refs.RkmModal.show()
        },
        edit(item, index) {
            this.$emit('handleAlter', item, index)
            this.$refs.RkmModal.hide()
        },
        getStringDiaSemana(dia) {

            if(dia == '1'){
               return 'DOMINGO'

            } else if (dia == '2'){
               return 'SEGUNDA-FEIRA'

            } else if (dia == '3'){
               return 'TERÇA-FEIRA'

            } else if (dia == '4'){
               return 'QUARTA-FEIRA'

            } else if (dia == '5'){
               return 'QUINTA-FEIRA'

            } else if (dia == '6'){
               return 'SEXTA-FEIRA'

            } else if (dia == '7'){
               return 'SÁBADO'
            }
        },
        getTempoAtendimento(tempo) {

            return tempo > 1 ? `${tempo} minutos` : `${tempo} minuto`
        },
    },
    props: {
        model: { type: Object, required: true },
        habilitaAgendamentoApp: { type: Boolean, default: false },
    },
    mixins: [ error, repository ],
}
</script>